import { RouteInfo } from './immobilier-routes.config';

export const PAYMENT_ROUTES: RouteInfo[] = [
  {
    path: '/homecpnt/payment-dashboard',
    title: 'Tableau de bord',
    icon: 'dashboard',
    class: ''
  },

/*  {
    path: '/homecpnt/situation-forfaitaire',
    title: 'Situation Forfaitaire',
    icon: 'history',
    class: ''
  },
*/
  {
    path: '/homecpnt/payment-reporting',
    title: 'Reporting Transactions',
    icon: 'history',
    class: ''
  }
];
